// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4.7 3.3H2.65C2.07 3.3 1.6 3.77 1.6 4.35V12.65C1.6 13.23 2.07 13.7 2.65 13.7H6.75C7.33 13.7 7.8 13.23 7.8 12.65V2.95C7.8 2.37 7.33 1.9 6.75 1.9H5.75C5.17 1.9 4.7 2.37 4.7 2.95V13.7',
  'M10.55 3.28L11.36 3.1C11.85 2.99 12.21 3.28 12.32 3.78L14.22 12.57C14.33 13.07 14.06 13.45 13.57 13.56L12.76 13.74C12.27 13.85 11.9 13.55 11.79 13.05L9.89 4.26C9.78 3.76 10.06 3.39 10.55 3.28Z',
];
